<template>
	<div class="sub-menu-container">
		<el-submenu :index="parent.id">
			<div slot="title">
				<i class="right_icon"></i>
				<span>{{ parent.name }}</span>
			</div>
			<div v-for="(item, index) in parent.child" :key="'menu-item' + index">
				<menu-item v-if="!item.child.length" index="/product/profile" :item="item">
				</menu-item>
				<sub-menu v-else :parent="item"></sub-menu>
			</div>
		</el-submenu>
	</div>
</template>

<script>
import MenuItem from './MenuItem'
export default {
	name: 'sub-menu',
	components: {
		MenuItem,
	},
	props: {
		parent: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {}
	},
}
</script>
<style lang="scss" scoped>
.sub-menu-container {
}
.right_icon {
	display: inline-block;
	width: 18px;
	height: 18px;
	background: url('../assets/right.png') no-repeat;
}
</style>

